import { cn } from '@heroui/react'
import { AlertTriangle, CheckCircle } from 'lucide-react'

const Alert = ({
  color,
  title,
  description,
}: {
  color: 'success' | 'danger'
  title?: string
  description: string
}) => {
  return (
    <div
      className={cn(
        'border border-red-200  bg-red-500/10 dark:border-red-800 rounded-lg transform transition-all duration-300 ease-in-out w-full',
        color === 'success'
          ? 'bg-green-500/10 dark:border-green-800'
          : 'bg-red-500/10 dark:border-red-800',
      )}
    >
      <div className="px-4 py-3">
        <div className="flex flex-row gap-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="flex-shrink-0">
              {color === 'success' ? (
                <CheckCircle className="w-5 h-5 text-green-500 dark:text-green-400" />
              ) : (
                <AlertTriangle className="w-5 h-5 text-red-500 dark:text-[#DD524C]" />
              )}
            </div>
            <div className="flex-1">
              <p
                className={cn(
                  'text-sm font-medium',
                  color === 'success'
                    ? 'text-green-900 dark:text-green-100'
                    : 'text-red-900 dark:text-red-100',
                )}
              >
                {title}
              </p>
              <p
                className={cn(
                  'text-sm font-medium',
                  color === 'success'
                    ? 'text-green-900 dark:text-green-100'
                    : 'text-red-900 dark:text-red-100',
                )}
              >
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <Button onPress={() => setIsDismissed(true)}>
                <X className="w-5 h-5 text-red-500 dark:text-[#DD524C]" />

            </Button> */}
    </div>
  )
}

export default Alert
